import { render, staticRenderFns } from "./UnitsAtTerminal.vue?vue&type=template&id=32f74876&"
import script from "./UnitsAtTerminal.vue?vue&type=script&lang=js&"
export * from "./UnitsAtTerminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports